import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { if (user) navigate("/dashboard"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <main className="pt-28 pb-20 min-h-screen flex items-center">
      <div className="max-w-md mx-auto px-5 w-full">
        <div className="rounded-3xl border border-white/10 bg-[#131519] p-8 relative grain overflow-hidden">
          <img src="/nasarawa-mark.png" alt="Nasarawa Expo" className="w-14 h-14 object-contain mb-6" />
          <div className="overline-label mb-2">Staff Access</div>
          <h1 className="font-heading text-2xl font-bold">Sign in to your dashboard</h1>
          <p className="text-sm text-zinc-400 mt-2">For Super Admin, National ICT Lead and LGA ICT Leads.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 bg-[#0B0C0E] border-white/10" data-testid="admin-login-email" required /></div>
            <div><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 bg-[#0B0C0E] border-white/10" data-testid="admin-login-password" required /></div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#E6197E] hover:bg-[#C4136B] rounded-full font-semibold" data-testid="admin-login-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
            </Button>
          </form>
        </div>
      </div>
    </main>
  );
}
